/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 17:20:14
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-29 14:51:06
 * @FilePath: /unifyxp-v2-store-portal/src/components/LinkImgDraggableDisplay/index.tsx
 */
/**
 *  Product Draggable
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import React from 'react';

//import css from './SalesChannelEditorPromotion.less';

import LinkImage from '@/src/constrains/LinkImg';
import DragNDropColumns from 'src/components/DragNDropColumns';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const LinkImgDraggableDisplay = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    droppableId,
    data,
    onChange,
    onSort,
    onDelete,
    hideAdd,
    onAdd,
    addText,
    //To Do Delete Link Temp
    linkSet,
    error = {},
    showImageDisplaySetting,
    disabled,
    disableDrag,
  } = props;

  const _onDelete = (index, E) => {
    if (onDelete) {
      onDelete(index, E);
    }
  };

  const childGenerate = (data, index, length) => {
    const {
      linkImage,
      uuid,
      draggableId,
      linkType,
      label,
      action,
      salesChannelUuid,
    } = data || {};

    // console.log({ uuid, linkType, label, action });
    const imageErrorArray = error[`${draggableId}linkImageError`] || [];
    const linkTypeErrorArray = error[`${draggableId}linkTypeError`] || [];
    //console.log('linkTypeErrorArray', linkTypeErrorArray);
    return (
      <LinkImage
        showImageDisplaySetting={showImageDisplaySetting}
        imageErrorArray={imageErrorArray}
        linkTypeErrorArray={linkTypeErrorArray}
        linkSet={linkSet}
        {...(onDelete && length > 1
          ? {
              onDelete: (e) => {
                _onDelete(index, e);
              },
            }
          : {})}
        linkImage={linkImage}
        link={{ linkType, uuid, label, action, salesChannelUuid }}
        title={`${getI18n('general.checkImgDraggableDisplay.title')} ${
          index + 1
        }`}
        linkId={`link${draggableId}-${index}`}
        subtitle={getI18n('general.checkImgDraggableDisplay.subtitle')}
        linkOnChange={(link) => {
          if (onChange) {
            onChange(index, link);
          }
        }}
        imgOnChange={(img) => {
          if (onChange) {
            onChange(index, { linkImage: img });
          }
        }}
        disabled={disabled}
      />
    );
  };

  const _onSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    if (onSort) onSort(newIndex, oldIndex);
  };

  return (
    <React.Fragment>
      <DragNDropColumns
        hideTitle
        childGenerate={childGenerate}
        data={data}
        droppableId={droppableId}
        onSort={_onSort}
        hideAdd={hideAdd}
        onAdd={onAdd}
        addText={addText}
        disabled={disabled}
        hideDrag={disabled || disableDrag}
      />
    </React.Fragment>
  );
};
export default LinkImgDraggableDisplay;
